import { useNavigate, useParams } from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import { boolean } from 'yup'
import moneyPoolBox from '../../../store/redux/moneyPoolBox'
import useSetDeactivate from '../deactivate/hooks/useSetDeactivate'
import {
    useDeleteMoneyPoolCashin,
    useDeleteMoneyPoolCashout,
} from './hooks/useDeleteTransaction'

interface IModalProps {
    show: boolean
    onHide: () => void
    moneypoolId: number
    transactionId: number
    isMoneypoolCashin: boolean
}

const DeleteTransactionModal = ({
    show,
    onHide,
    moneypoolId,
    transactionId,
    isMoneypoolCashin,
}: IModalProps) => {
    const { isLoadingTransactionsAfterDeleteCashin, mutateCashin } =
        useDeleteMoneyPoolCashin()
    const { isLoadingTransactionsAfterDeleteCashout, mutateCashout } =
        useDeleteMoneyPoolCashout()
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className="max-h-36 h-36">
                <p className="text-center text-xl pt-3 mb-3">
                    از حذف تراکنش خود اطمینان دارید؟
                </p>
                <div className=" flex flex-row text-lg justify-content-center">
                    <button
                        className="bg-red-3 text-white w-28 h-16 ml-4 rounded-md"
                        onClick={() => {
                            if (isMoneypoolCashin) {
                                const payload: {
                                    moneypoolId: number
                                    cashinId: number
                                } = {
                                    moneypoolId: moneypoolId,
                                    cashinId: transactionId,
                                }
                                mutateCashin(payload)
                                onHide()
                            } else {
                                const payload: {
                                    moneypoolId: number
                                    cashoutId: number
                                } = {
                                    moneypoolId: moneypoolId,
                                    cashoutId: transactionId,
                                }
                                mutateCashout(payload)
                                onHide()
                            }
                        }}
                    >
                        حذف تراکنش
                    </button>
                    <button
                        className="w-28 h-16 border-1 border-gray-4 rounded-md "
                        onClick={onHide}
                    >
                        انصراف
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteTransactionModal
